// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/common/v1/client_errors.proto (package kitecorp.transferify.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/common/v1/client_errors.proto.
 */
export const file_kitecorp_transferify_common_v1_client_errors: GenFile = /*@__PURE__*/
  fileDesc("CjJraXRlY29ycC90cmFuc2ZlcmlmeS9jb21tb24vdjEvY2xpZW50X2Vycm9ycy5wcm90bxIea2l0ZWNvcnAudHJhbnNmZXJpZnkuY29tbW9uLnYxItcEChhSZXBvcnRDbGllbnRFcnJvclJlcXVlc3QSDQoFYnJhbmQYASABKAkSUQoHc3VyZmFjZRgCIAEoDjJALmtpdGVjb3JwLnRyYW5zZmVyaWZ5LmNvbW1vbi52MS5SZXBvcnRDbGllbnRFcnJvclJlcXVlc3QuU3VyZmFjZRJPCgZsb2NhbGUYAyABKA4yPy5raXRlY29ycC50cmFuc2ZlcmlmeS5jb21tb24udjEuUmVwb3J0Q2xpZW50RXJyb3JSZXF1ZXN0LkxvY2FsZRINCgVyb3V0ZRgEIAEoCRIMCgRuYW1lGAUgASgJEhQKB21lc3NhZ2UYBiABKAlCA4ABARITCgZmcmFtZXMYByADKAlCA4ABARIbCg5hYnNvcmJlZF9jb3VudBgIIAEoBUgAiAEBEhYKCWJ1aWxkX3NoYRgJIAEoCUgBiAEBIn0KB1N1cmZhY2USFwoTU1VSRkFDRV9VTlNQRUNJRklFRBAAEhkKFVNVUkZBQ0VfUk9PVF9CT1VOREFSWRABEhwKGFNVUkZBQ0VfQ09OVEVOVF9CT1VOREFSWRACEiAKHFNVUkZBQ0VfVFJBTlNMQVRFRF9ET01fR1VBUkQQAyJrCgZMb2NhbGUSFgoSTE9DQUxFX1VOU1BFQ0lGSUVEEAASDQoJTE9DQUxFX0VOEAESDQoJTE9DQUxFX1JPEAISDQoJTE9DQUxFX0RFEAMSDQoJTE9DQUxFX0ZSEAQSDQoJTE9DQUxFX0lUEAVCEQoPX2Fic29yYmVkX2NvdW50QgwKCl9idWlsZF9zaGEygQEKEkNsaWVudEVycm9yU2VydmljZRJrChFSZXBvcnRDbGllbnRFcnJvchI4LmtpdGVjb3JwLnRyYW5zZmVyaWZ5LmNvbW1vbi52MS5SZXBvcnRDbGllbnRFcnJvclJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiBIq1GABCQwosY29tLmtpdGVjb3JwLmNvbnRyYWN0cy50cmFuc2ZlcmlmeS5jb21tb24udjFCEUNsaWVudEVycm9yc1Byb3RvUAFiBnByb3RvMw", [file_google_protobuf_empty, file_kitecorp_options_v1_options]);

/**
 * One caught error. The only beacon with free text, because the message is the diagnostic, so the api bounds and
 * redacts the text before it writes anything down. The report carries no account, address, page content or resolved
 * URL.
 *
 * @generated from message kitecorp.transferify.common.v1.ReportClientErrorRequest
 */
export type ReportClientErrorRequest = Message<"kitecorp.transferify.common.v1.ReportClientErrorRequest"> & {
  /**
   * The brand key: the brand site's registrable domain, such as transferify.ro, which the api checks against its
   * configured brands.
   *
   * @generated from field: string brand = 1;
   */
  brand: string;

  /**
   * The part of the page that caught the error.
   *
   * @generated from field: kitecorp.transferify.common.v1.ReportClientErrorRequest.Surface surface = 2;
   */
  surface: ReportClientErrorRequest_Surface;

  /**
   * The language the page was shown in.
   *
   * @generated from field: kitecorp.transferify.common.v1.ReportClientErrorRequest.Locale locale = 3;
   */
  locale: ReportClientErrorRequest_Locale;

  /**
   * The route pattern the page was on, never the resolved path, because a path can carry a download link's capability.
   *
   * @generated from field: string route = 4;
   */
  route: string;

  /**
   * The error's constructor name; the api accepts it only when it is an error class name.
   *
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * The error's text. It can quote what the page showed, so a log hides it.
   *
   * @generated from field: string message = 6;
   */
  message: string;

  /**
   * The error's stack frames. They can quote the page's content, so a log hides them.
   *
   * @generated from field: repeated string frames = 7;
   */
  frames: string[];

  /**
   * How many DOM mutations the translated-DOM guard absorbed over a session. Absent on every other surface, and zero is
   * refused: a report that nothing happened would be one request per session from every reader.
   *
   * @generated from field: optional int32 absorbed_count = 8;
   */
  absorbedCount?: number | undefined;

  /**
   * The build the page was served from, when the page knows it.
   *
   * @generated from field: optional string build_sha = 9;
   */
  buildSha?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.common.v1.ReportClientErrorRequest.
 * Use `create(ReportClientErrorRequestSchema)` to create a new message.
 */
export const ReportClientErrorRequestSchema: GenMessage<ReportClientErrorRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_common_v1_client_errors, 0);

/**
 * The part of the page that caught the error.
 *
 * @generated from enum kitecorp.transferify.common.v1.ReportClientErrorRequest.Surface
 */
export enum ReportClientErrorRequest_Surface {
  /**
   * Never sent. Present because every proto3 enum needs a zero value.
   *
   * @generated from enum value: SURFACE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The error boundary around the whole page.
   *
   * @generated from enum value: SURFACE_ROOT_BOUNDARY = 1;
   */
  ROOT_BOUNDARY = 1,

  /**
   * The error boundary around a page's content.
   *
   * @generated from enum value: SURFACE_CONTENT_BOUNDARY = 2;
   */
  CONTENT_BOUNDARY = 2,

  /**
   * The guard against a browser's translation tool rewriting the page.
   *
   * @generated from enum value: SURFACE_TRANSLATED_DOM_GUARD = 3;
   */
  TRANSLATED_DOM_GUARD = 3,
}

/**
 * Describes the enum kitecorp.transferify.common.v1.ReportClientErrorRequest.Surface.
 */
export const ReportClientErrorRequest_SurfaceSchema: GenEnum<ReportClientErrorRequest_Surface> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_common_v1_client_errors, 0, 0);

/**
 * The language the page was shown in.
 *
 * @generated from enum kitecorp.transferify.common.v1.ReportClientErrorRequest.Locale
 */
export enum ReportClientErrorRequest_Locale {
  /**
   * Never sent. Present because every proto3 enum needs a zero value.
   *
   * @generated from enum value: LOCALE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * English.
   *
   * @generated from enum value: LOCALE_EN = 1;
   */
  EN = 1,

  /**
   * Romanian.
   *
   * @generated from enum value: LOCALE_RO = 2;
   */
  RO = 2,

  /**
   * German.
   *
   * @generated from enum value: LOCALE_DE = 3;
   */
  DE = 3,

  /**
   * French.
   *
   * @generated from enum value: LOCALE_FR = 4;
   */
  FR = 4,

  /**
   * Italian.
   *
   * @generated from enum value: LOCALE_IT = 5;
   */
  IT = 5,
}

/**
 * Describes the enum kitecorp.transferify.common.v1.ReportClientErrorRequest.Locale.
 */
export const ReportClientErrorRequest_LocaleSchema: GenEnum<ReportClientErrorRequest_Locale> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_common_v1_client_errors, 0, 1);

/**
 * The errors a browser's page catches in its own code and reports (kitecorp/contracts#69). Anonymous: an error can
 * happen before any sign-in.
 *
 * @generated from service kitecorp.transferify.common.v1.ClientErrorService
 */
export const ClientErrorService: GenService<{
  /**
   * Reports one caught error. It is a beacon: the answer is empty, and a repeat counts again, so the call is left with
   * unknown idempotency and a client must not retry it on its own.
   *
   * @generated from rpc kitecorp.transferify.common.v1.ClientErrorService.ReportClientError
   */
  reportClientError: {
    methodKind: "unary";
    input: typeof ReportClientErrorRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_common_v1_client_errors, 0);

